import { chartSearchDurationsOptions, Input, useState } from "@";

const Card = ({
  title,
  children,
  noSelect,
  className = "",
  description,
  selectedDuration,
  searchDurationUpdated,
}) => {
  const [searchDuration, setSearchDuration] = useState(
    chartSearchDurationsOptions[selectedDuration || 3].value,
  );

  const handleSearchDurationChange = (value) => {
    setSearchDuration(value);
    searchDurationUpdated && searchDurationUpdated(value);
  };

  return (
    <div className={`${className} card relative p-4`}>
      <div className="relative flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <h2 className="text-[15px] font-semibold tracking-tight text-gray-700 dark:text-gray-400">
            {title}
          </h2>
          {!noSelect ? (
            <p className="mt-0.5 hidden text-[11px] font-medium uppercase tracking-[0.14em] text-purple-700/80 dark:text-purple-400/80 sm:block">
              {chartSearchDurationsOptions[searchDuration].name}
            </p>
          ) : description ? (
            <p className="mt-0.5 hidden text-xs font-normal text-gray-500 dark:text-gray-400 sm:block">
              {description}
            </p>
          ) : null}
        </div>

        {!noSelect && (
          <div className="flex items-center gap-1.5">
            <Input
              star
              type="select"
              noEmptyOption
              value={searchDuration}
              list={chartSearchDurationsOptions}
              style={chartSearchDurationsOptions[searchDuration].width}
              change={(e) => handleSearchDurationChange(e.target.value)}
              className="bg-white px-0 py-1.5 text-[13px] text-gray-500 dark:bg-gray-800"
            />
          </div>
        )}
      </div>
      <div className="relative">{children}</div>
    </div>
  );
};
export default Card;
